import {
  put, all, call, select, takeEvery, takeLatest, fork, cancel,
} from 'redux-saga/effects';

import sheetsSaga from './sheets/saga';
import bookSaga from './book/saga';

export default function* (context) {
  yield all([sheetsSaga(context), bookSaga(context)]);
}
